import React, { useEffect, useState, useRef, useCallback } from 'react'
import PropTypes from 'prop-types'

// styles
import '@aytm/lib/rfd-ui/styles/basic/hover-target.scss'

HoverTarget.propTypes = {
  hovered: PropTypes.bool,
  className: PropTypes.string,
  gracePeriod: PropTypes.number,
  children: PropTypes.any
}
export default function HoverTarget(props) {
  const { className, children, gracePeriod = 200, hovered: propsHovered = false, ...restProps } = props

  const leaveGracePeriodTimer = useRef(null)
  const [hovered, setHovered] = useState(propsHovered)

  // sync props to state
  useEffect(() => {
    setHovered(propsHovered)
  }, [propsHovered])

  const onMouseEnter = useCallback(() => {
    if (null != leaveGracePeriodTimer.current) {
      clearTimeout(leaveGracePeriodTimer.current)
      leaveGracePeriodTimer.current = null
    }
    if (!hovered) {
      setHovered(true)
    }
  }, [hovered, setHovered])

  const onMouseLeave = useCallback(() => {
    if (leaveGracePeriodTimer.current) {
      clearTimeout(leaveGracePeriodTimer.current)
    }
    leaveGracePeriodTimer.current = setTimeout(() => {
      leaveGracePeriodTimer.current = null
      setHovered(false)
    }, gracePeriod)
  }, [setHovered, gracePeriod])

  return (
    <span
      {...restProps}
      className={`rfd-ui-hover-target${className ? ' ' + className : ''}`}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      {children(hovered, setHovered)}
    </span>
  )
}
